import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { Button, WContainer, WImage } from '@next-nx/shared-ui/atoms'
import styles from './ImageTextBanner.module.sass'


interface Props {
  item: MenuItemType | undefined
  className?: string
  handleTracking?: (t: string) => void
}

const ImageTextBanner = (props: Props) => {

  const { 
    item = undefined,
    className = '',
    handleTracking = () => undefined
  } = props

  return item ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer variant="lg">
        <div className={styles.layout}>
          <div className={styles.content}>
            {!!item.name && <p className={styles.title}>{item.name}</p>}
            {!!item.description && <div className={styles.description} dangerouslySetInnerHTML={{ __html: item.description }} />}
            {!!item.ctaLabel && !!item.url && (
              <div className={styles.ctaBox}>
                <Button label={item.ctaLabel} href={item.url} newPage={item.blank} variant="secondary" color="white" handleTracking={() => handleTracking(item.ctaLabel)} />
              </div>
            )}
          </div>
          <div className={`${styles.imageBox} ${item.imageMobile ? styles['imageBox--desktop'] : ''}`}>
            <WImage 
              src={item.image}
              alt={item.name}
              title={item.name}
              maxWidth={1920}
              maxHeight={414}
              layout="fill"
              objectFit="cover"
            />
          </div>
        </div>
      </WContainer>
    </div>
  ) : <></>
}

export default ImageTextBanner
